<template>
  <suspense>
    <template #default>
      <dashboard-layout></dashboard-layout>
    </template>

    <template #fallback>
      Chargement...
    </template>
  </suspense>
</template>

<script> 
  import DashboardLayout from './dashboard-layout'

  export default {
    components: {
      DashboardLayout,
    }
  }
</script>
